module.exports = __webpack_public_path__ + "assets/0b0d29b511037706a41eafd7cc306e48.svg";